import { store } from "./store";
import { Link } from "react-router-dom";

const english = {
    "general": {
        "settings": "Settings",
        "registrations": "Registrations",
        "privacy_policy": "Privacy Policy",
        "terms_conditions": "Terms & Conditions",
        "knowledge_base": "Knowledge Base",
        "saving_data": "Saving registration data...",
        "new_registration_heading": "Are you sure you want to start a new registration?",
        "new_registration_body": "If you start a new registration, the current registration information will be cleared.",
        "powered_by": "Powered by ",
    },
    "fields": {
        "first_name": "First Name",
        "last_name": "Last Name",
        "middle_name": "Middle Name/Initial",
        "suffix": "Suffix",
        "birth_date": "Birth Date (mm/dd/yyyy)",
        "race": "Race (optional)",
        "sex": "Sex",
        "email_address": "Email Address",
        "phone_number": "Phone Number",
        "phone_type_select_label": "Select phone type...",
        "phone_type_select": "- Select Type -",
        "phone_type": "Phone Type",
        "cell_phone": "Cell Phone",
        "home_phone": "Home Phone",
        "work_phone": "Work Phone",
        "license_id": "PA Driver's License or PennDOT ID Card #",
        "last_four_ssn": "Last Four Digits of SSN",
        "street_address": "Street Address",
        "street_address_2": "Street Address 2",
        "unit_type": "Unit Type (if applicable)",
        "unit_number": "Unit Number (if applicable)",
        "city": "City",
        "state": "State",
        "zipcode": "ZIP Code",
        "county": "County Where You Live",
        "municipality": "Municipality Where You Live",
        "election_district": "Election District (if known)",
        "assistant_name": "Name of person who assisted in the completion of this application",
        "previous_first_name": "Previous First Name",
        "previous_last_name": "Previous Last Name",
        "previous_middle_name": "Previous Middle Name/Initial",
        "is_interested_poll_worker": "I would like to be a poll worker on election day.",
        "is_interested_interpreter": "I would like to be a bilingual interpreter on Election Day",
        "interpreter_language": "I speak this language",
        "no_address": "I do not have a street address or permanent residence.",
        "yes_assistance": "Yes, someone assisted me in signing.",
        "no_assistance": "No, I signed myself.",
        "last_four": "Please enter the LAST FOUR digits of your Social Security number.",
        "mailing_address": "Mailing Address",
        "mailing_address_2": "Mailing Address 2",
        "mailing_city": "Mailing City",
        "mailing_state": "Mailing State",
        "mailing_zipcode": "Mailing ZIP Code (Ex. 12345 or 12345-6789)",
        "mailing_country": "Mailing Country",
        "mailing_address_in_usa": "Is the address in the United States?",
        "mailing_address_is_my": "Mailing Address Is My … (e.g. vacation home, temporary residence, etc.)",
        "political_party": "Political Party",
        "party_other": "If Other, Please Specify",
        "previous_address": "Previous Street Address",
        "previous_city": "Previous City",
        "previous_state": "Previous State",
        "previous_county": "Previous County",
        "previous_zipcode": "Previous ZIP Code",
        "na": "n/a",
        "ballot_mailing_address": "Mail ballot to address",
        "ballot_mailing_city": "Mail ballot to city",
        "ballot_mailing_state": "Mail ballot to state is",
        "ballot_mailing_zipcode": "Mail ballot to ZIP Code (Ex. 12345 or 12345-6789)",
        "ballot_mailing_zipcode_short": "Mail ballot to ZIP Code",
        "ballot_mailing_country": "Mail ballot to country",
        "ballot_mailing_ward_short": "Ward or Voting District",
        "ballot_mailing_lived_since_short": "Lived at address since",
    },
    "placeholders": {
        "dropdown": "- Select -",
        "first_name": "Jane",
        "last_name": "Doe",
        "middle_name": "Henry",
        "suffix": "Jr., II, etc",
        "birth_date": "mm/dd/yyyy",
        "email_address": "you@example.com",
        "phone_number": "555-555-5555",
        "select_an_item": "Select an item...",
        "select_phone_type": "Select phone type...",
        "license_id": "12 345 678",
        "street_address": "5555 Oak St.",
        "street_address_2": "5555 Oak St.",
        "unit_number": "40B",
        "city": "City",
        "zipcode": "12345",
        "municipality": "Select a county first...",
        "political_party": "Political Party",
        "mailing_address_is_my": "vacation home, temporary residence, etc.",
    },
    "validation": {
        "id": "The PA driver's license or PennDOT ID card information you entered is not valid. Please confirm your PA driver's license or PennDOT ID card information",
        "first_name": "Your first name is required.",
        "last_name": "Your last name is required.",
        "middle_name": "Your middle name is not valid.",
        "birth_date": "Your birth date is required.",
        "birth_date_valid": "Please input a valid birth date.",
        "email_address": "Your email address is required.",
        "email_address_format": "The format of the email address is incorrect. Please correct and try again.",
        "phone_number_required": "Your phone number is required.",
        "phone_number_valid": "The phone number provided is not valid. Please enter a valid phone number.",
        "license_id": "Please provide a value.",
        "license_id_valid": "Please enter a valid license number.",
        "ssn": "",
        "street_address": "Your street address is required.",
        "city": "Your city is required.",
        "state": "Please select a state.",
        "zipcode": "Your ZIP code is required.",
        "zipcode_valid": "Please enter a valid 5 digit ZIP code.",
        "no_address_zipcode": "Your ZIP code is required or click the check box indicating that you do not have one.",
        "no_address_zipcode_valid": "Please enter a valid 5 digit zip code or click the check box indicating that you do not have one.",
        "county": "Your county of residence is required.",
        "signature_confirmation_title": "Confirmation Error",
        "signature_confirmation_message": "Please confirm that you have read and agree to the terms.",
        "assistant_confirmation_title": "Confirmation Error",
        "assistant_confirmation_message": "Please indicate assistance was provided with the completion of this form.",
        "previous_first_name": "First Name is required for a Name Change application",
        "previous_last_name": "Previous Last Name is required for a Name Change application",
        "previous_middle_name": "Previous middle name is not valid.",
        "select_option": "Please select an option.",
        "provide_value": "Please provide a value.",
        "provide_language": "Please provide a language.",
        "no_address": "Your street address is required or click the check box indicating that you do not have one",
        "mailing_address": "Your mailing address is required",
        "mailing_city": "Your mailing city is required",
        "mailing_state": "Your mailing state is required",
        "mailing_zipcode": "The ZIP code must be 5 digits or 9 digits (zip code + 4)",
        "mailing_address_is_my": "Please provide a value for this field",
        "mailing_country": "Your mailing country is required.",
        "party": "Please select a political party.",
        "party_other": "Warning - Party is not selected. If Other is selected, the Other party text box should be completed.",
        "previous_address": "Address of Previous Registration is required for an Address Change application",
        "previous_city": "City of Previous Registration is required for an Address change application",
        "previous_state": <>Previous state must be Pennsylvania. If you have recently moved to Pennsylvania from another state, you must <Link className="underline" to={'/new-registration'} state={{ resetRegistration: true }}>submit a new registration</Link> rather than a change of address.</>,
        "previous_county": "Previous County Registration is required for an Address Change application.",
        "previous_zipcode": "The ZIP code must be 5 digits or 9 digits (zip code + 4)",
        "previous_zipcode_required": "ZIP of Previous Registration is required for an Address Change application.",
        "phone_type": "Please select an option.",
        "valid_option": "Please select an option.",
        "valid_value": "Please enter a valid value.",
        'na': 'n/a',
        "mailing_address_limit": "Please Note:  Mailling Address, Mailing Address 2, Unit Type, and Unit Number have a maximum combined character limit of 40.",
    },
    "buttons": {
        "lets_get_started": "Let's Get Started",
        "new_registrant": "New Registration",
        "update_registration": "Update Registration",
        "no_changes": "I have no changes to make",
        "proceed": "Proceed",
        "continue": "Continue",
        "cancel": "Cancel",
        "yes": "Yes",
        "no": "No",
        "no_ssn": "I don't have my SSN with me",
        "next_step": "Next Step",
        "update_information": "Update Information",
        "add_signature": "Add Signature",
        "clear_signature": "Clear Signature",
        "accept_signature": "Accept Signature",
        "complete_registration": "Complete Registration",
        "start_new_registration": "Start New Submission",
        "continue_registration": "Continue Registration",
        "sign_up": "Sign Up",
        "stay_in_touch": "Stay In Touch",
        "back": "Back",
        "continue_without_ssn": "Proceed Without SSN",
        "continue_without_id": "Proceed Without PennDot ID",
        "download": "Download",
    },

    "home": {
        heading: "Welcome to Register to Vote PA.",
        content: "Would you like to register to vote or update your registration?",
        id_required_heading: "PA Driver's License or PennDOT ID Required",
        id_required_body: "In order to submit a mail-in ballot request, a PA Driver's License or PennDot ID number is required. Do you want to proceed?",
    },
    "comingsoon": {
        heading: "Welcome to Register to Vote PA.",
        content: "To get started, check out the Register to Vote PA application in the Play Store.",
    },
    "additional_questions": {
        heading: "Would you like to be a poll worker on Election Day?",
        content: "Please indicate your preference below.",
    },
    "address_information": {
        heading: "Please provide us the information, below.",
    },
    "add_signature": {
        heading: "Review the statement and sign to verify your registration.",
        review_your_signature: "Review Your Signature:",
        review_signature_terms_confirm: "I confirm that I have read and agree to the terms above.",
        review_signature_sign: "Sign here using your mouse or finger if on a mobile device:",
    },
    "assistance_add_signature": {
        heading: "Assistant: Please review the statement below and sign to confirm agreement to the terms.",
        review_your_signature: "Review Your Signature:",
        review_signature_terms_confirm: "I confirm that I have read and agree to the terms above.",
        review_signature_sign: "Sign here using your mouse or finger if on a mobile device:",
    },
    "assistance_information": {
        heading: "Please have the assistant provide their address and signature.",
        content: "Please add your name and address below.",
    },
    "confirmation": {
        heading: "Registration Processing!",
        content: "Thank you for submitting a voter registration application!",
        content_with_email: "We'll send you a confirmation email and keep in touch about other services coming up on voting day.",
        support: <>
            <p>The decision on your voter registration is ultimately made by your county voter registration office. If you have any questions about your application, please reach out to your county for clarification. For further support, kindly email us at <a href="mailto:help@registertovotepa.app" className="underline">help@registertovotepa.app</a>.</p>
        </>,
    },
    "current_address": {
        heading: "Please enter your current address of residence.",
    },
    "eligibility_age": {
        valid_age_question: "Will you be 18 years or older on or before election day?",
    },

    "eligibility_citizenship": {
        us_citizen_question: "Are you a citizen of the U.S.?",
    },
    "eligibility_notice": {
        heading: "To register you must:",
        content_1: <>Be <u>a United States citizen</u> at least 30 days before the next election</>,
        content_2: <>Be <u>a resident of Pennsylvania</u> and your election district for at least 30 days before the next election</>,
        content_3: <>Be <u>at least 18 years of age</u> on the day of the next election</>,
        heading_important_dates: "Important Deadlines for the next election:",
        important_dates_registration: "Voter Registration Deadline:",
        important_dates_mailin: "Mail-in Ballot Request Received:",
        important_dates_mailin_return: "Mail-in Ballot Received:",
    },
    "had_assistance": {
        heading: "Did someone assist you in signing this?",
        content: "If you were unable to sign this form due to a physical disability, you may have had an assistant do so on your behalf. That assistant must provide his or her signature and address in the space provided. By signing, the assistant certifies that he or she signed the form at your request.",
    },
    "has_mailing_address": {
        heading: "Is your mailing address the same as your residential address?",
        mailing_ask_yes: "Yes, my mailing and residential addresses are the same.",
        mailing_ask_no: "No, I have a different mailing address.",
    },
    "id_entry": {
        heading: "Enter the information on your PennDOT ID.",
        content: "Please fill out the form below based on your current information. Please note: this is not where you update your name or address.",
        content_2: "You may not use a P. O. Box address.",
        no_id_heading: "The PennDot ID option has been selected, but no number has been entered.",
        no_id_body: "Do you want to proceed without entering a PennDot ID?",
    },
    "id_verification": {
        heading: "Do you have a PA driver's license or PennDOT ID card number?",
        content: "The easiest way for us to register you is with your Driver License or PennDOT ID, but we can also do so if you have a social security number.",
        license_ask_have_id: "I have my PA driver's license or PennDOT ID card number with me right now.",
        license_ask_no_id: "I have a PA driver's license or PennDOT ID card number, but I don't have it with me right now.",
        license_ask_have_ssn: "I do not have a PA driver's license or PennDOT ID card number, but I have a Social Security Number.",
        license_ask_no_id_ssn: "I do not have a PA driver's license or PennDOT ID card or a Social Security Number.",
        hava_disclaimer: <em><span className="text-xs">Please note if you do not provide a PennDOT ID number, or if the number you provide is not correct, your county will contact you to complete your application.</span></em>,
        no_id_ssn_checkbox: "Lorem Ipsum",
    },
    "last_four_entry": {
        heading: "Since you do not have a PennDot number please enter the last 4 digits of your Social Security number.",
        with_id_heading: "Please enter the last 4 digits of your Social Security number.",
        no_ssn_heading: "The Social Security Number (SSN) option has been selected, but no number has been entered.",
        no_ssn_body: "Do you want to proceed without entering a Social Security Number?",
    },
    "mailing_address": {
        heading: "Please provide us with your mailing address.",
        content: "We'll need your current mailing address to get you registered.",
    },
    "new_address": {
        heading: "Please enter your new address.",
    },
    "new_name": {
        heading: "Please enter your new name.",
    },
    "not_eligible": {
        heading: "We won't be able to register you today.",
        content: "We'll keep in touch about other services coming on voting day!",
    },
    "page_not_found": {
        heading: "Page Not Found",
    },
    "paper_application": {
        heading: "Please ask your canvasser for a paper application.",
        content: "Since you do not have a permanent address, we'll need you to fill out a paper application. Don't worry, we can still help you get registered!",
    },
    "party_affiliation": {
        heading: "What is your political party affiliation?",
    },
    "previous_address": {
        heading: "Please enter your address of previous registration.",
        content: <>If you have recently moved to Pennsylvania from another state, you must <Link className="underline" to={'/new-registration'} state={{ resetRegistration: true }}>submit a new registration</Link> rather than a change of address.,</>
    },
    "previous_name": {
        heading: "Please enter your previous name.",
    },
    "privacy": {
        heading: "Privacy Policy",
        content: <>
            <p>This Privacy Policy and the Terms of Use apply to all users of the Register to Vote PA voter registration mobile application (the "App"), including Registrants, Canvassers, and Organizations, as those terms are defined below ("users" or "you").</p>
            <p>The App is being made available by Voter Registration Project ("we," or "us"), which is authorized to permit other organizations ("Organizations"), through their employees, contractors, and/or volunteers ("Canvassers"), to use the App to register people to vote in the Commonwealth of Pennsylvania ("Registrants"). Before you use or submit any information in connection with the App, carefully review this Privacy Policy and Terms of Use. By using the App, you consent to the collection, use, and disclosure of your information, and the terms and conditions of use, as outlined below.</p>
            <p>We will continue to review these policies and we may make changes to them from time to time. The date at the bottom of this page indicates the last time changes were made. You should check this page periodically for updates. Your continued use of the App will signify that you have read, understood, and accepted the terms of the updated Privacy Policy and Terms of Use.</p>
            <p>&nbsp;</p>

            <p className="text-center underline"><strong>PRIVACY POLICY</strong></p>
            <p><strong>For Registrants</strong></p>
            <p><strong>You may only enter information in the App to register to vote if you are a U.S. citizen and otherwise eligible to register, as indicated by prompts in the App.</strong></p>
            <p>The App will ask you to enter information about yourself that is ultimately submitted to your County Commissioner's Office/Board of Elections to process your registration. This information may include:</p>
            <ul>
                <li>Full Name; </li>
                <li>Date; </li>
                <li>Residence address; </li>
                <li>Mailing address;</li>
                <li>Address of previous residence immediately before moving to current residence;</li>
                <li>Date of birth; </li>
                <li>Race;</li>
                <li>Party;</li>
                <li>Sex;</li>
                <li>Phone number;</li>
                <li>Email address;</li>
                <li>Penndot ID Number and/or the last 4 digits of your Social Security Number;</li>
                <li>Whether you have resided within the Commonwealth of Pennsylvania for at least 30 days prior to the next Election Day;</li>
                <li>Whether you are a citizen of the United States of America for at least 30 days prior to the next Election Day;</li>
                <li>Whether you will be 18 years of age or older on the next Election Day; </li>
                <li>Whether you need assistance voting;</li>
                <li>Whether you are interested in being a poll worker;</li>
                <li>Whether you want to apply to vote by mail or, if you have previously voted by mail, whether you want to request instead that the information be transferred from last year's request to receive a mail in ballot again;</li>
                <li>Your driver's license number; and</li>
                <li>An image of your signature</li>
            </ul>
            <p>The Organization who collects this information from you will send this information to your County Commissioner's Office/Board of Elections to process your registration. The Organization who collects your information may retain the above information about you, except for your driver's license number and the last four digits of your Social Security Number. The Organization may use this information for the following purposes:</p>
            <ul>
                <li>To contact you with information about how, where and when to vote;</li>
                <li>To contact you to encourage you to vote in elections;</li>
                <li>To contact you with other information Organization believes may be of interest to you;</li>
                <li>For research purposes, when combined with information from other Registrants and Canvassers, including, by way of example, to analyze and study patterns in voter registration, the effectiveness of various voter registration methods and approaches, and characteristics of new registrants; </li>
                <li>To maintain and/or improve the App; and</li>
                <li>For business operations, including for security, fraud prevention, and legal compliance.</li>
            </ul>
            <p>The Organization will not use your information for any commercial purpose, including soliciting you to purchase goods or services, or for any purpose prohibited by applicable law. </p>
            <p>The Organization may share and/or disclose your information (except for your driver's license number and the last four digits of your Social Security Number) under the following circumstances:</p>
            <ul>
                <li>To state, local or federal government agencies if and when required by applicable law;</li>
                <li>To academic or research institutions or providers for non-commercial purposes; </li>
                <li>To other nonpartisan organizations engaged in voter registration and mobilization efforts for non-commercial purposes;</li>
                <li>To Voter Registration Project and its family of organizations</li>
                <li>If the Organization acquires, merges or partners with other organizations; and</li>
                <li>If the information is aggregated and/or de-identified information.</li>
            </ul>
            <p>&nbsp;</p>

            <p><strong>For Canvassers</strong></p>
            <p>Canvassers must use the App only in accordance with the instructions and training they have been provided.</p>
            <p>Canvassers may not personally retain any information of any kind collected from Registrants using the App, and may not share any such information with any other person or entity other than the Organization on whose behalf Canvasser is using the App. </p>
            <p>Canvassers will be asked to enter certain information about themselves before each shift trying to register voters using the App. This may include your name, email address, username and password, Partner Code, and the date, time, and location of each shift trying to register voters using the App.</p>
            <p>The information you submit will be used to confirm that you are a Canvasser entitled to access the App. In addition, the information you submit and information about the voter registrations you complete may be used by for the following purposes:</p>
            <ul>
                <li>To track the progress of Organization's voter registration programs;</li>
                <li>To contact you for more information about any particular registrations you collected;</li>
                <li>To contact you with information Organization believes may be of interest to you;</li>
                <li>For research purposes, when combined with information from other Canvassers and Registrants, including, by way of example, to study and analyze patterns in voter registrations, the effectiveness of voter registration methods and approaches, and characteristics of new registrants;</li>
                <li>To maintain and/or improve the App; and</li>
                <li>For business operations, including for security, fraud prevention, and legal compliance.</li>
            </ul>
            <p>The Organization will not use your information for any commercial purpose, including soliciting you to purchase goods or services, or for any purpose prohibited by applicable law. </p>
            <p>The Organization may share and/or disclose your information under the following circumstances:</p>
            <ul>
                <li>To state, local or federal government agencies if and when required by applicable law;</li>
                <li>To academic or research institutions or providers for non-commercial purposes; </li>
                <li>To other nonpartisan organizations engaged in voter registration and mobilization efforts for non-commercial purposes;</li>
                <li>To Voter Registration Project and its family of organizations</li>
                <li>If the Organization acquires, merges or partners with other organizations; and</li>
                <li>If the information is aggregated and/or de-identified information.</li>
            </ul>
            <p>&nbsp;</p>

            <p><strong>For Organizations </strong></p>
            <p>The following information collected from Registrants may only be conveyed to the election authorities and CANNOT be retained by your organization:</p>
            <ul>
                <li>Driver's license number</li>
                <li>Last four digits of a Registrant's Social Security Number</li>
            </ul>
            <p>Other information collected through the App from Registrants and Canvassers may be retained by the Organization. The Organization may use this information for the following purposes: </p>
            <ul>
                <li>To contact Registrants with information about how, where and when to vote;</li>
                <li>To contact Registrants to encourage them to vote in elections;</li>
                <li>To track the progress of Organization's voter registration programs;</li>
                <li>To contact Canvassers for more information if needed about any particular registrations collected;</li>
                <li>To contact Registrants and Canvassers with information Organization believes may be of interest to them;</li>
                <li>For research purposes, when combined with information from other Registrants and Canvassers, including, by way of example, to analyze and study patterns in voter registration, the effectiveness of various voter registration methods and approaches, and characteristics of new registrants; </li>
                <li>To maintain and/or improve the App; and</li>
                <li>For business operations, including for security, fraud prevention, and legal compliance.</li>
            </ul>
            <p>The Organization cannot use such information for any commercial purpose, including soliciting Registrants or Canvassers to purchase goods or services, or for any purpose prohibited by applicable law. </p>
            <p>The Organization may share and/or disclose information obtained from Registrants and Canvassers (except for Registrants' driver's license numbers and the last four digits of their Social Security Numbers) under the following circumstances:</p>
            <ul>
                <li>To state, local or federal government agencies if and when required by applicable law;</li>
                <li>To academic or research institutions or providers for non-commercial purposes; </li>
                <li>To other nonpartisan organizations engaged in voter registration and mobilization efforts for non-commercial purposes;</li>
                <li>To Voter Registration Project and its family of organizations</li>
                <li>If the Organization acquires, merges or partners with other organizations; and</li>
                <li>If the information is aggregated and/or de-identified information.</li>
            </ul>
            <p>&nbsp;</p>
            <p>If you have any questions about this Privacy Policy or Terms of Use, you can contact us by emailing us at help@registertovotepa.app.</p>
            <p>&nbsp;</p>
            <p>Last Updated: 4/13/26</p>
        </>,
    },
    "registration": {
        heading_1: "Let's get started on your registration!",
        heading_2: "Update Registration",
        content: "Please confirm or provide the following information",
    },
    "registration_address": {
        heading: "Please enter your address for registration.",
    },
    "review": {
        heading: "Please confirm the information you provided.",
        content: "Please confirm that the information below is accurate. If information is incorrect, click on the edit icon at the top right corner of each section.",
        personal_info_heading: "Current Personal Information",
        residential_heading: "Residential Information",
        license_heading: "PA Driver's License or PennDOT ID",
        ssn_heading: "Social Security #",
        prev_name_heading: "Previous Name",
        prev_address_heading: "Previous Address",
        additional_info_heading: "Additional Information",
        email_optin: "Email Opt-In",
        phone_optin: "Phone Opt-In",
        county: "County",
        municipality: "Municipality",
        election_district: "Election District",
        years_lived_at_address: "Years Lived At Address",
        poll_worker: "Poll Worker",
        bilingual_interpreter: "Bilingual Interpreter",
        languages: "Language(s)",
        requires_help_to_vote: "Requires Help to Vote?",
        assistance_needed: "Assistance Needed",
        preferred_language: "Preferred Language",
        have_mailing_address: "I have a mailing address",
        ballot_request: "Annual Mail-in Ballot Application",
    },
    "required_help": {
        heading: "Do you require help to vote?",
        content: "Please indicate your preference below.",
        label: "I require help to vote. I need this kind of assistance.",
        language_label: "I require language help. My preferred language is:",
        type_error: "Please select the type of assistance required",
    },
    "stay_in_touch": {
        heading: "Let's Stay In Touch!",
        content: "We'll keep in touch about our organization",
    },
    "thank_you": {
        heading: "Thank You!",
        content: "We'll keep in touch about other services coming up on voting day!",
    },
    "terms": {
        heading: "Terms & Conditions",
        content: <>
            <p>Terms Content</p>
        </>,
    },
    "update_information": {
        heading: "It looks like you're registered to vote! Do you need to make any changes to your registration?",
        content: "Please select all that apply",
        error: "Please check at least one box.",
        change_name: "I need to change my name on voter registration.",
        change_address: <>I need to change the address linked to my voter registration.<br /><em><span className="text-xs">If you have recently moved to Pennsylvania from another state, you must <Link className="underline" to={'/new-registration'} state={{ resetRegistration: true }}>submit a new registration</Link> rather than a change of address. </span></em></>,
        change_party: "I need to change my political party affiliation.",
        federal_employee: "I am a Federal or State employee registering in my county of last residence.",
    },

    "ballot_request": {
        heading: "Annual Mail-In Ballot Application",
        content: "If you would like to receive mail-in ballots for the remainder of this year and if you would like to automatically receive an annual application for mail-in ballots each year, please indicate below.",
        content2: "Your name, address, county, date of birth, and PA driver's license or PennDOT ID card number provided on the previous screens will be used for your Mail-In Ballot Application.",
        label: "Would you like to receive mail-in ballots for any election you qualify for?",
        address_type_label: "Mail ballot to me at the following address:",
        address_type_1: "Residential Address",
        address_type_2: "Mailing Address",
        address_type_3: "Alternate Address",
        ballot_request_type_error: "You must select an address where your ballot is to be mailed to.",
        ballot_ward_label: "Please indicate your Ward or Voting District (if known)",
        ballot_lived_since_label: "I have lived at this address since:",
        ballot_lived_since_error: "Please provide the year you moved to this address.",
        ballot_lived_since_error_2: "Please provide a valid year.",
        id_text: "Identification: Your PA driver's license or PennDOT ID card number provided above will be used for your Mail-In Ballot Application. If this information is not correct please make any necessary edits in ID Info.",
        id_field: "PA Driver's License of PennDOT ID card number: ",
        annual_request: "If you would like to apply to receive mail-in ballots for the remainder of this year and if you would like to automatically receive an annual application for mail-in ballots each year, please indicate below. If you update your voter registration due to relocation out of county after you submit an annual mail-in ballot request, please ensure your annual status is transferred when updating your address.",
        annual_request_field: "I would like to receive mail-in ballots this year and receive annual applications for mail-in ballots each year.",
        confirmation_heading: "Please review the statement below and sign to confirm agreement to the terms.",
        review_terms_confirm: "I confirm that I have read and agree to the terms above.",
    },
}

const spanish = {
    "general": {
        "settings": "Configuración",
        "registrations": "Inscripciones",
        "privacy_policy": "Política de privacidad",
        "terms_conditions": "Términos y condiciones",
        "knowledge_base": "Base de conocimientos",
        "saving_data": "Guardar los datos de registro...",
        "new_registration_heading": "¿Está seguro de que desea empezar una nueva inscripción?",
        "new_registration_body": "Si comienza una nueva inscripción, se borrarán los datos de inscripción actuales.",
        "powered_by": "Powered by ",
    },
    "fields": {
        "first_name": "Nombre",
        "last_name": "Apellido",
        "middle_name": "Segundo nombre/inicial",
        "suffix": "Sufijo",
        "birth_date": "Fecha de nacimiento",
        "race": "Raza (opcional)",
        "sex": "Sexo",
        "email_address": "Dirección de correo electrónico",
        "phone_number": "Número de teléfono",
        "phone_type_select_label": "Seleccione el tipo de teléfono...",
        "phone_type_select": "Seleccionar tipo",
        "phone_type": "Tipo de teléfono",
        "cell_phone": "Teléfono móvil",
        "home_phone": "Teléfono de la casa",
        "work_phone": "Teléfono de oficina",
        "license_id": "N.º de licencia de conducir de PA o N.º de ID de PennDOT requerido",
        "last_four_ssn": "Últimos cuatro dígitos del SSN",
        "street_address": "Dirección",
        "street_address_2": "Dirección 2",
        "unit_type": "Tipo de unidad (si es necesario)",
        "unit_number": "N.º de unidad (si es necesario)",
        "city": "Ciudad",
        "state": "Estado",
        "zipcode": "Código postal",
        "county": "Condado donde vive",
        "municipality": "Municipalidad donde vive",
        "election_district": "Distrito electoral (si se conoce)",
        "assistant_name": "Nombre de la persona que colaboró para completar esta solicitud.",
        "previous_first_name": "Primer nombre anterior",
        "previous_last_name": "Apellido anterior",
        "previous_middle_name": "Segundo nombre/inicial anterior",
        "is_interested_poll_worker": "Me gustaría ser un trabajador electoral el día de las elecciones.",
        "is_interested_interpreter": "Me gustaría ser un intérprete bilingüe el día de las elecciones.",
        "interpreter_language": "Hablo este idioma:",
        "no_address": "No tengo dirección ni residencia permanente.",
        "yes_assistance": "Sí, alguien me ayudó a firmarlo.",
        "no_assistance": "No, lo firmé yo mismo.",
        "last_four": "Ingrese los ÚLTIMOS CUATRO dígitos del número de Seguro Social.",
        "mailing_address": "Dirección postal",
        "mailing_address_2": "Dirección postal (Línea 2)",
        "mailing_city": "Ciudad de destino",
        "mailing_state": "Estado de destino",
        "mailing_zipcode": "Código postal de destino (Ex. 12345 o 12345-6789)",
        "mailing_country": "País de destino",
        "mailing_address_in_usa": "¿Esta dirección está en los Estados Unidos?",
        "mailing_address_is_my": "La dirección postal es mi...(por ejemplo: casa de vacaciones, residencia temporal, etc.)",
        "political_party": "Partido político",
        "party_other": "Si elige Otro, especifique:",
        "previous_address": "Dirección",
        "previous_city": "Ciudad",
        "previous_state": "Estado",
        "previous_county": "Condado",
        "previous_zipcode": "Código Postal",
        "na": "n/a",
        "ballot_mailing_address": "Enviar boleta a la dirección",
        "ballot_mailing_city": "Enviar boleta a la ciudad",
        "ballot_mailing_state": "Enviar boleta al estado",
        "ballot_mailing_zipcode": "Enviar boleta al código postal (Ej. 12345 o 12345-6789)",
        "ballot_mailing_zipcode_short": "Enviar boleta al código postale",
        "ballot_mailing_country": "Enviar boleta al país",
        "ballot_mailing_ward_short": "Distrito de votación",
        "ballot_mailing_lived_since_short": "Vivo en esta dirección desde",
    },
    "placeholders": {
        "dropdown": "- Seleccione -",
        "first_name": "Jane",
        "last_name": "Doe",
        "middle_name": "Henry",
        "suffix": "Jr., II, etc",
        "birth_date": "mm/dd/aaaa",
        "email_address": "you@example.com",
        "phone_number": "555-555-5555",
        "select_an_item": "Seleccione un elemento...",
        "select_phone_type": "Seleccione el tipo de teléfono...",
        "license_id": "12 345 678",
        "street_address": "5555 Oak St.",
        "street_address_2": "5555 Oak St.",
        "unit_number": "40B",
        "city": "Ciudad",
        "zipcode": "12345",
        "municipality": "Primero, seleccione un condado...",
        "political_party": "Partido político",
        "mailing_address_is_my": "casa de vacaciones, residencia temporal, etc.",
    },
    "validation": {
        "id": "La información de la licencia de conducir de PA o de la tarjeta de ID de PennDOT que introdujo no es válida. Confirme la información de la licencia de conducir de PA o de la tarjeta de ID de PennDOT.",
        "first_name": "Debe introducir su nombre.",
        "last_name": "Debe introducir su apellido.",
        "middle_name": "Su segundo nombre no es válido.",
        "birth_date": "Debe introducir su fecha de nacimiento.",
        "birth_date_valid": "Ingrese una fecha de nacimiento válida.",
        "email_address": "Introduzca su dirección de correo electrónico.",
        "email_address_format": "El formato de la dirección de correo electrónico es incorrecto. Corríjalo e inténtelo nuevamente.",
        "phone_number_required": "Debe introducir su número de teléfono.",
        "phone_number_valid": "El número de teléfono facilitado no es válido. Ingrese un número de teléfono válido.",
        "license_id": "Ingrese un valor.",
        "license_id_valid": "La información de la licencia de conducir de PA o de la tarjeta de ID de PennDOT que introdujo no es válida. Confirme la información de la licencia de conducir de PA o de la tarjeta de ID de PennDOT.",
        "ssn": "Ingrese los ÚLTIMOS CUATRO dígitos del número de Seguro Social.",
        "street_address": "Debe introducir una dirección postal.",
        "city": "Debe introducir su ciudad.",
        "state": "Seleccione un estado.Seleccione un estado.",
        "zipcode": "Debe introducir un código postal.",
        "zipcode_valid": "Ingrese un código postal de cinco dígitos válido.",
        "no_address_zipcode": "Debe introducir un código postal.",
        "no_address_zipcode_valid": "Ingrese un código postal de cinco dígitos válido.",
        "county": "Debe introducir el condado de residencia.",
        "signature_confirmation_title": "Error de confirmación",
        "signature_confirmation_message": "Por favor, confirme que leyó y acepta los términos.",
        "assistant_confirmation_title": "Error de confirmación",
        "assistant_confirmation_message": "Indique si recibió ayuda para completar este formulario.",
        "previous_first_name": "El primer nombre anterior es necesario para una solicitud de cambio de nombre",
        "previous_last_name": "El apellido anterior es necesario para una solicitud de cambio de nombre",
        "previous_middle_name": "El segundo nombre anterior no es válido.",
        "select_option": "Seleccione una opción.",
        "provide_value": "Ingrese un valor.",
        "provide_language": "Ingrese un idioma.",
        "no_address": "Debe introducir una dirección postal.",
        "mailing_address": "Debe introducir una dirección postal.",
        "mailing_city": "Debe introducir su ciudad.",
        "mailing_state": "Seleccione un estado.",
        "mailing_zipcode": "Debe introducir un código postal.",
        "mailing_address_is_my": "Ingrese un valor.",
        "mailing_country": "Su país de envío es obligatorio.",
        "party": "Seleccione un partido político.",
        "party_other": "Advertencia: no se seleccionó un partido. Si selecciona Otro, debe completarse el campo de Otro partido.",
        "previous_address": "La dirección de inscripción anterior es necesaria para una solicitud de cambio de dirección",
        "previous_city": "La ciudad de inscripción anterior es obligatoria para solicitar cambio de dirección.",
        "previous_state": <>El estado anterior debe ser Pensilvania. Si se mudó recientemente a Pensilvania, debe presentar <Link className="underline" to={'/new-registration'} state={{ resetRegistration: true }}>una nueva inscripción</Link> en lugar de un cambio de dirección.</>,
        "previous_county": "El condado de inscripción anterior es necesario para una solicitud de cambio de dirección.",
        "previous_zipcode": "El código postal de inscripción anterior es necesario para una solicitud de cambio de dirección",
        "previous_zipcode_required": "El código postal de inscripción anterior es necesario para una solicitud de cambio de dirección",
        "phone_type": "Seleccione una opción.",
        "valid_option": "Seleccione una opción.",
        "valid_value": "Seleccione un valor válido.",
        'na': 'n/a',
        "mailing_address_limit": "Por favor, tenga en cuenta: Dirección postal, Dirección postal 2, Tipo de unidad y Número de unidad tienen un límite máximo de 40 caracteres en total",
    },
    "buttons": {
        "lets_get_started": "Comencemos",
        "new_registrant": "Nueva inscripción",
        "update_registration": "Actualizar inscripción",
        "no_changes": "No tengo que hacer ningún cambio",
        "proceed": "Continuar",
        "continue": "Continuar",
        "cancel": "Cancelar",
        "yes": "Sí",
        "no": "No",
        "no_ssn": "No cuento con mi SSN ",
        "next_step": "Siguiente paso",
        "update_information": "Actualizar información",
        "add_signature": "Agregar firma",
        "clear_signature": "Borrar firma",
        "accept_signature": "Aceptar firma",
        "complete_registration": "Completar inscripción",
        "start_new_registration": "Iniciar una nueva solicitud",
        "continue_registration": "Continuar con la solicitud",
        "sign_up": "Registrarse",
        "stay_in_touch": "Manténgase en contacto",
        "back": "Atrás",
        "continue_without_ssn": "Continuar sin el SSN",
        "continue_without_id": "Continuar sin la identificación de PennDot",
        "download": "Descargar",
    },

    "home": {
        heading: "¡Bienvenido a la aplicación Register to Vote PA!",
        content: "¿Le gustaría inscribirse para votar o actualizar su inscripción?",
        id_required_heading: "N.º de licencia de conducir de PA o N.º de ID de PennDOT requerido",
        id_required_body: "ES - In order to submit a mail-in ballot request, a PA Driver's License or PennDot ID number is required. Do you want to proceed?",
    },
    "comingsoon": {
        heading: "¡Bienvenido a la aplicación Register to Vote PA!",
        content: "Para comenzar, echa un vistazo a la aplicación Register to Vote PA en la Play Store.",
    },
    "additional_questions": {
        heading: "¿Le gustaría ser un trabajador electoral el día de las elecciones?",
        content: "Indique su preferencia a continuación.",
    },
    "address_information": {
        heading: "A continuación, facilítenos su información.",
    },
    "add_signature": {
        heading: "Lea la siguiente declaración y firme para confirmar su inscripción.",
        review_your_signature: "Revise su firma:",
        review_signature_terms_confirm: "Confirmo que leí y aceptos los términos anteriores.",
        review_signature_sign: "Firme aquí con su dedo o lapicera para tableta:",
    },
    "assistance_add_signature": {
        heading: "Asistente: Lea la siguiente declaración y firme para confirmar que acepta los términos.",
        review_your_signature: "Revise su firma:",
        review_signature_terms_confirm: "Confirmo que leí y aceptos los términos anteriores.",
        review_signature_sign: "Firme aquí con su dedo o lapicera para tableta:",
    },
    "assistance_information": {
        heading: "Entréguele la tableta al asistente para que pueda facilitar su dirección y firma.",
        content: "Agregue su nombre y dirección a continuación.",
    },
    "confirmation": {
        heading: "¡Inscripción en trámite!",
        content: "¡Gracias por enviar una solicitud de inscripción del votante!",
        content_with_email: "¡Le enviaremos un correo electrónico de confirmación y lo mantendremos informado sobre otros servicios que estarán disponibles el día de las elecciones.",
        support: <>
            <p>La decisión sobre su inscripción del votante la toma, en última instancia, la oficina de inscripción de votantes de su condado. Si tiene preguntas sobre su solicitud, comuníquese con el condado para obtener más información. Si desea obtener más asistencia, envíenos un correo electrónico a <a href="mailto:help@registertovotepa.app" className="underline">help@registertovotepa.app</a>.</p>
        </>,
    },
    "current_address": {
        heading: "ES - Please enter your current address of residence.",
    },
    "eligibility_age": {
        valid_age_question: "¿Será mayor de 18 años el día de la elección o antes?",
    },

    "eligibility_citizenship": {
        us_citizen_question: "¿Es ciudadano es los Estados Unidos?",
    },
    "eligibility_notice": {
        heading: "A fin de registrarse, debe:",
        content_1: <>Ser un <u>ciudadano estadounidense</u> al menos 30 días antes de la próxima elección</>,
        content_2: <>Ser un <u>residente de Pensilvania</u> y del distrito electoral durante al menos 30 días antes de la próxima elección</>,
        content_3: <>Tener <u>18 años de edad, como mínimo,</u> el día de la próxima elección</>,
        heading_important_dates: "Fechas límite importantes para la próxima elección:",
        important_dates_registration: "Fecha límite para la inscripción del votante:",
        important_dates_mailin: "Se ha recibido la solicitud de voto por correo:",
        important_dates_mailin_return: "Se ha recibido la boleta para votar por correo:",
    },
    "had_assistance": {
        heading: "¿Alguien lo ayudó a firmar esto?",
        content: "Si no pudo firmar este formulario por una discapacidad física, es posible que haya pedido a un asistente que lo hiciera en su nombre. El asistente debe firmar e indicar una dirección en el espacio proporcionado. Al firmar, el asistente certifica que firmó el formulario a petición suya.",
    },
    "has_mailing_address": {
        heading: "¿La dirección postal es la misma que le dirección residencial?",
        mailing_ask_yes: "Si, mi dirección postal y mi dirección residencial es la misma.",
        mailing_ask_no: "No, tengo una dirección postal distinta.",
    },
    "id_entry": {
        heading: "Ingrese la información de la identificación de PennDOT.",
        content: "Complete el formulario a continuación en función de su información actual. Tenga en cuenta que no es donde actualiza su nombre ni dirección.",
        content_2: "No puede usar una dirección postal.",
        no_id_heading: "ES - The PennDot ID option has been selected, but no number has been entered.",
        no_id_body: "ES - Do you want to proceed without entering a PennDot ID?",
    },
    "id_verification": {
        heading: "¿Tiene un número de licencia de conducir de PA o de la tarjeta de ID de PennDOT?",
        content: "La forma más sencilla de inscribirlo es mediante la licencia de conducir o la ID de PennDOT, pero también podemos hacerlo si cuenta con un número de seguro social.",
        license_ask_have_id: "Cuento con el número de mi licencia de conducir de PA o de la tarjeta de ID de PennDOT en este momento.",
        license_ask_no_id: "Cuento con el número de mi licencia de conducir de PA o de la tarjeta de ID de PennDOT, pero no lo tengo en este momento.",
        license_ask_have_ssn: "No cuento con el número de mi licencia de conducir de PA o de la tarjeta de ID de PennDOT, pero tengo el Número de Seguro Social.",
        license_ask_no_id_ssn: "No cuento con un número de licencia de conducir de PA, ni de la tarjeta de ID de PennDOT ni un Número de Seguro Social.",
        hava_disclaimer: <em><span className="text-xs">Tenga en cuenta que, si no facilita un número de ID de PennDOT o si el número proporcionado no es correcto, su condado se contactará con usted para completar su solicitud.</span></em>,
        no_id_ssn_checkbox: "ES - Lorem Ipsum",
    },
    "last_four_entry": {
        heading: "Dado que no tiene un número de PennDOT, ingrese los últimos 4 dígitos del número de Seguro Social.",
        with_id_heading: "Ingrese los últimos 4 dígitos del número de Seguro Social.",
        no_ssn_heading: "ES - The Social Security Number (SSN) option has been selected, but no number has been entered.",
        no_ssn_body: "ES - Do you want to proceed without entering a Social Security Number?",
    },
    "mailing_address": {
        heading: "A continuación, facilítenos su dirección postal.",
        content: "Necesitaremos su dirección postal actual para inscribirlo.",
    },
    "new_address": {
        heading: "Ingrese su dirección nueva.",
    },
    "new_name": {
        heading: "Ingrese su nombre nuevo.",
    },
    "not_eligible": {
        heading: "No podremos inscribirlo/a hoy.",
        content: "¡Seguiremos en contacto para informar sobre otros servicios que se ofrecerán el día de la votación!",
    },
    "page_not_found": {
        heading: "No se encontró la página",
    },
    "paper_application": {
        heading: "Pídale al captador de votos un formulario de solicitud en papel.",
        content: "Dado que no tiene una dirección permanente, tendrá que completar una solicitud en papel. ¡No se preocupe, aún podemos ayudarlo a inscribirse!",
    },
    "party_affiliation": {
        heading: "¿Cuál es su afiliación política?",
    },
    "previous_address": {
        heading: "Ingrese la dirección de la inscripción anterior.",
        content: <>Si se mudó recientemente a Pensilvania, debe presentar <Link className="underline" to={'/new-registration'} state={{ resetRegistration: true }}>una nueva inscripción</Link> en lugar de un cambio de dirección.,</>
    },
    "previous_name": {
        heading: "Ingrese su nombre anterior",
    },
    "privacy": {
        heading: "Política de privacidad",
        content: <>
            <p>This Privacy Policy and the Terms of Use apply to all users of the Register to Vote PA voter registration mobile application (the "App"), including Registrants, Canvassers, and Organizations, as those terms are defined below ("users" or "you").</p>
            <p>The App is being made available by Voter Registration Project ("we," or "us"), which is authorized to permit other organizations ("Organizations"), through their employees, contractors, and/or volunteers ("Canvassers"), to use the App to register people to vote in the Commonwealth of Pennsylvania ("Registrants"). Before you use or submit any information in connection with the App, carefully review this Privacy Policy and Terms of Use. By using the App, you consent to the collection, use, and disclosure of your information, and the terms and conditions of use, as outlined below.</p>
            <p>We will continue to review these policies and we may make changes to them from time to time. The date at the bottom of this page indicates the last time changes were made. You should check this page periodically for updates. Your continued use of the App will signify that you have read, understood, and accepted the terms of the updated Privacy Policy and Terms of Use.</p>
            <p>&nbsp;</p>

            <p className="text-center underline"><strong>PRIVACY POLICY</strong></p>
            <p><strong>For Registrants</strong></p>
            <p><strong>You may only enter information in the App to register to vote if you are a U.S. citizen and otherwise eligible to register, as indicated by prompts in the App.</strong></p>
            <p>The App will ask you to enter information about yourself that is ultimately submitted to your County Commissioner's Office/Board of Elections to process your registration. This information may include:</p>
            <ul>
                <li>Full Name; </li>
                <li>Date; </li>
                <li>Residence address; </li>
                <li>Mailing address;</li>
                <li>Address of previous residence immediately before moving to current residence;</li>
                <li>Date of birth; </li>
                <li>Race;</li>
                <li>Party;</li>
                <li>Sex;</li>
                <li>Phone number;</li>
                <li>Email address;</li>
                <li>Penndot ID Number and/or the last 4 digits of your Social Security Number;</li>
                <li>Whether you have resided within the Commonwealth of Pennsylvania for at least 30 days prior to the next Election Day;</li>
                <li>Whether you are a citizen of the United States of America for at least 30 days prior to the next Election Day;</li>
                <li>Whether you will be 18 years of age or older on the next Election Day; </li>
                <li>Whether you need assistance voting;</li>
                <li>Whether you are interested in being a poll worker;</li>
                <li>Whether you want to apply to vote by mail or, if you have previously voted by mail, whether you want to request instead that the information be transferred from last year's request to receive a mail in ballot again;</li>
                <li>Your driver's license number; and</li>
                <li>An image of your signature</li>
            </ul>
            <p>The Organization who collects this information from you will send this information to your County Commissioner's Office/Board of Elections to process your registration. The Organization who collects your information may retain the above information about you, except for your driver's license number and the last four digits of your Social Security Number. The Organization may use this information for the following purposes:</p>
            <ul>
                <li>To contact you with information about how, where and when to vote;</li>
                <li>To contact you to encourage you to vote in elections;</li>
                <li>To contact you with other information Organization believes may be of interest to you;</li>
                <li>For research purposes, when combined with information from other Registrants and Canvassers, including, by way of example, to analyze and study patterns in voter registration, the effectiveness of various voter registration methods and approaches, and characteristics of new registrants; </li>
                <li>To maintain and/or improve the App; and</li>
                <li>For business operations, including for security, fraud prevention, and legal compliance.</li>
            </ul>
            <p>The Organization will not use your information for any commercial purpose, including soliciting you to purchase goods or services, or for any purpose prohibited by applicable law. </p>
            <p>The Organization may share and/or disclose your information (except for your driver's license number and the last four digits of your Social Security Number) under the following circumstances:</p>
            <ul>
                <li>To state, local or federal government agencies if and when required by applicable law;</li>
                <li>To academic or research institutions or providers for non-commercial purposes; </li>
                <li>To other nonpartisan organizations engaged in voter registration and mobilization efforts for non-commercial purposes;</li>
                <li>To Voter Registration Project and its family of organizations</li>
                <li>If the Organization acquires, merges or partners with other organizations; and</li>
                <li>If the information is aggregated and/or de-identified information.</li>
            </ul>
            <p>&nbsp;</p>

            <p><strong>For Canvassers</strong></p>
            <p>Canvassers must use the App only in accordance with the instructions and training they have been provided.</p>
            <p>Canvassers may not personally retain any information of any kind collected from Registrants using the App, and may not share any such information with any other person or entity other than the Organization on whose behalf Canvasser is using the App. </p>
            <p>Canvassers will be asked to enter certain information about themselves before each shift trying to register voters using the App. This may include your name, email address, username and password, Partner Code, and the date, time, and location of each shift trying to register voters using the App.</p>
            <p>The information you submit will be used to confirm that you are a Canvasser entitled to access the App. In addition, the information you submit and information about the voter registrations you complete may be used by for the following purposes:</p>
            <ul>
                <li>To track the progress of Organization's voter registration programs;</li>
                <li>To contact you for more information about any particular registrations you collected;</li>
                <li>To contact you with information Organization believes may be of interest to you;</li>
                <li>For research purposes, when combined with information from other Canvassers and Registrants, including, by way of example, to study and analyze patterns in voter registrations, the effectiveness of voter registration methods and approaches, and characteristics of new registrants;</li>
                <li>To maintain and/or improve the App; and</li>
                <li>For business operations, including for security, fraud prevention, and legal compliance.</li>
            </ul>
            <p>The Organization will not use your information for any commercial purpose, including soliciting you to purchase goods or services, or for any purpose prohibited by applicable law. </p>
            <p>The Organization may share and/or disclose your information under the following circumstances:</p>
            <ul>
                <li>To state, local or federal government agencies if and when required by applicable law;</li>
                <li>To academic or research institutions or providers for non-commercial purposes; </li>
                <li>To other nonpartisan organizations engaged in voter registration and mobilization efforts for non-commercial purposes;</li>
                <li>To Voter Registration Project and its family of organizations</li>
                <li>If the Organization acquires, merges or partners with other organizations; and</li>
                <li>If the information is aggregated and/or de-identified information.</li>
            </ul>
            <p>&nbsp;</p>

            <p><strong>For Organizations </strong></p>
            <p>The following information collected from Registrants may only be conveyed to the election authorities and CANNOT be retained by your organization:</p>
            <ul>
                <li>Driver's license number</li>
                <li>Last four digits of a Registrant's Social Security Number</li>
            </ul>
            <p>Other information collected through the App from Registrants and Canvassers may be retained by the Organization. The Organization may use this information for the following purposes: </p>
            <ul>
                <li>To contact Registrants with information about how, where and when to vote;</li>
                <li>To contact Registrants to encourage them to vote in elections;</li>
                <li>To track the progress of Organization's voter registration programs;</li>
                <li>To contact Canvassers for more information if needed about any particular registrations collected;</li>
                <li>To contact Registrants and Canvassers with information Organization believes may be of interest to them;</li>
                <li>For research purposes, when combined with information from other Registrants and Canvassers, including, by way of example, to analyze and study patterns in voter registration, the effectiveness of various voter registration methods and approaches, and characteristics of new registrants; </li>
                <li>To maintain and/or improve the App; and</li>
                <li>For business operations, including for security, fraud prevention, and legal compliance.</li>
            </ul>
            <p>The Organization cannot use such information for any commercial purpose, including soliciting Registrants or Canvassers to purchase goods or services, or for any purpose prohibited by applicable law. </p>
            <p>The Organization may share and/or disclose information obtained from Registrants and Canvassers (except for Registrants' driver's license numbers and the last four digits of their Social Security Numbers) under the following circumstances:</p>
            <ul>
                <li>To state, local or federal government agencies if and when required by applicable law;</li>
                <li>To academic or research institutions or providers for non-commercial purposes; </li>
                <li>To other nonpartisan organizations engaged in voter registration and mobilization efforts for non-commercial purposes;</li>
                <li>To Voter Registration Project and its family of organizations</li>
                <li>If the Organization acquires, merges or partners with other organizations; and</li>
                <li>If the information is aggregated and/or de-identified information.</li>
            </ul>
            <p>&nbsp;</p>
            <p>If you have any questions about this Privacy Policy or Terms of Use, you can contact us by emailing us at help@registertovotepa.app.</p>
            <p>&nbsp;</p>
            <p>Last Updated: 4/13/26</p>
        </>,
    },
    "registration": {
        heading_1: "¡Empecemos con la inscripción!",
        heading_2: "Actualizar inscripción",
        content: "Confirme o presente la siguiente información.",
    },
    "registration_address": {
        heading: "ES - Please enter your address for registration.",
    },
    "review": {
        heading: "Confirme la información que proporcionó.",
        content: "Confirme que la siguiente información es precisa. Si la información es incorrecta, haga clic en el ícono de edición en la esquina superior derecha de cada sección.",
        personal_info_heading: "Información personal actual",
        residential_heading: "Información residencial",
        license_heading: "Licencia de conducir de PA o ID de PennDOT",
        ssn_heading: "# del Seguro Social",
        prev_name_heading: "Nombre anterior",
        prev_address_heading: "Dirección anterior",
        additional_info_heading: "Información adicional",
        email_optin: "Suscripción por correo electrónico",
        phone_optin: "Suscripción por teléfono",
        county: "Condado",
        municipality: "Municipalidad",
        election_district: "Distrito electoral",
        years_lived_at_address: "Años de residencia en esta dirección",
        poll_worker: "Trabajador electoral",
        bilingual_interpreter: "Intérprete bilingüe",
        languages: "Idioma(s)",
        requires_help_to_vote: "¿Necesita ayuda para votar?",
        assistance_needed: "Se necesita ayuda",
        preferred_language: "Idioma de preferencia",
        have_mailing_address: "Tengo una dirección postal",
        ballot_request: "Solicitud anual de boleta para votar por correo",
    },
    "required_help": {
        heading: "¿Necesita ayuda para votar?",
        content: "Indique su preferencia a continuación.",
        label: "Necesito ayuda para votar. Necesito esta clase de ayuda: ",
        language_label: "Necesito ayuda con el idioma. Mi idioma de preferencia es:",
        type_error: "Seleccione el tipo de asistencia necesaria.",
    },
    "stay_in_touch": {
        heading: "¡Mantengámonos en contacto!",
        content: "Lo mantendremos informado sobre nuestra organización.",
    },
    "thank_you": {
        heading: "¡Gracias!",
        content: "¡Lo mantendremos informado sobre otros servicios que estarán disponibles el día de las elecciones!",
    },
    "terms": {
        heading: "Términos y condiciones",
        content: <>
            <p>ES - Terms Content</p>
        </>,
    },
    "update_information": {
        heading: "¿Debe hacer algún cambio en la inscripción?",
        content: "Seleccione todas las opciones que correspondan:",
        error: "Marque al menos una casilla.",
        change_name: "Tengo que cambiar mi nombre en la inscripción del votante.",
        change_address: <>Tengo que cambiar mi dirección en la inscripción del votante.<br /><em><span className="text-xs">Si se mudó recientemente a Pensilvania, debe presentar <Link className="underline" to={'/new-registration'} state={{ resetRegistration: true }}>una nueva inscripción</Link> en lugar de un cambio de dirección.</span></em></>,
        change_party: "Tengo que cambiar mi afiliación política.",
        federal_employee: "Soy un empleado federal o estatal y me inscribo en mi último condado de residencia.",
    },

    "ballot_request": {
        heading: "Solicitud anual de boleta para votar por correo",
        content: "Si le gustaría recibir boletas por correo para lo que queda de este año y si quisiera recibir automáticamente una solicitud anual de boleta para votar por correo cada año, indíquelo a continuación.",
        content2: "Su nombre, dirección, condado, fecha de nacimiento y licencia de conducir de PA o número de tarjeta de ID de PennDOT que se proporcionan en las pantallas anteriores utilizarán para su solicitud de boleta para votar por correo.",
        label: "¿Le gustaría recibir boletas por correo para cualquier elección a la que usted califique para participar?",
        address_type_label: "Enviar por correo la boleta para votar a la siguiente dirección:",
        address_type_1: "Dirección residencial",
        address_type_2: "Dirección postal",
        address_type_3: "Dirección alternativa",
        ballot_request_type_error: "Debe seleccionar una dirección donde se debe enviar su boleta.",
        ballot_ward_label: "Por favor, indique su distrito de votación (si se conoce)",
        ballot_lived_since_label: "Vivo en esta dirección desde el:",
        ballot_lived_since_error: "Indique el año en que se mudó a esta dirección.",
        ballot_lived_since_error_2: "Introduzca una año válido.",
        id_text: "Identificación: Su licencia de conducir de PA o número de tarjeta de ID de PennDOT que proporciona arriba se utilizarán para su solicitud de boleta para votar por correo. Si esta información no es correcta, haga las ediciones necesarias en la información de identificación.",
        id_field: "Número de licencia de conducir de PA o de la tarjeta de ID de PennDOT: ",
        annual_request: "Si le gustaría solicitar recibir boletas por correo para lo que queda de este año y si quisiera recibir automáticamente una solicitud anual de boleta para votar por correo cada año, indíquelo a continuación. Si actualiza su inscripción del votante debido a que se ha mudado fuera del condado después de haber enviado una solicitud anual de boleta para votar por correo, asegúrese de que se transfiera su situación anual al actualizar su dirección.",
        annual_request_field: "Me gustaría recibir boletas por correo este año y recibir solicitudes anuales de boletas para votar por correo cada año.",
        confirmation_heading: "Lea la siguiente declaración y firme para confirmar que acepta los términos.",
        review_terms_confirm: "CONFIRMO QUE LEÍ Y ACEPTO LOS TÉRMINOS ANTERIORES.",
    },
}


export const getContent = (section) => {
    const currentLanguage = store.getState().settings.currentLanguage
    const contentArray = section.split('.');

    if (currentLanguage === 'en') {
        return english[contentArray[0]][contentArray[1]];
    }
    if (currentLanguage === 'es') {
        return spanish[contentArray[0]][contentArray[1]];
    }
    console.error(`ERROR: Can't find section ${section} for ${currentLanguage}`);
}
